// removed by extract-text-webpack-plugin
module.exports = {"chip":"Chip__chip__3VFvP","small":"Chip__small__3bEuI","wrapper":"Chip__wrapper__1I2fy","icon":"Chip__icon__3S7NB","closeIcon":"Chip__closeIcon__1_Kev"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Chip/Chip.scss
// module id = 1636
// module chunks = 0